import React from "react";
import { FormGroup, FormCheck, FormControl } from "react-bootstrap";

import "../styles.css";

const RadioInput = ({
  value = null,
  id,
  radioData = [],
  width = "15%",
  handleChange,
  errorText = "",
  isForm = false,
}) => {
  return (
    <div style={{ width: width }}>
      <FormGroup className={`${isForm ? "d-flex" : ""} flex-column`}>
        {Boolean(radioData.length) &&
          radioData.map((radio, index) => {
            return (
              <FormCheck
                checked={(radio.value === value)}
                type="radio"
                id={`input-radio-${id}-${index}`}
                label={radio.label}
                name={id}
                onChange={handleChange}
                value={radio.value}
              />
            );
          })}

        {Boolean(errorText) && (
          <FormControl.Feedback type="invalid" style={{ display: "block" }}>
            {errorText}
          </FormControl.Feedback>
        )}
      </FormGroup>
    </div>
  );
};

export default RadioInput;
